// extracted by mini-css-extract-plugin
export default {"container":"feed-icon_container__O3VOy","image":"feed-icon_image__KS06I","image_black":"feed-icon_image_black__3mpxs","text":"feed-icon_text__lsQTE"};